import useGlobalStore from '@/stores/global.store';
import { useCancelOrderMutation } from './mutations/use-cancel-order-mutation';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as React from 'react';
import { useCode } from './use-code';

export function useCancelOrder() {
  const queryClient = useQueryClient();
  const orderId = useGlobalStore((state) => state.orderId);
  const browse = useGlobalStore((state) => state.browse);
  const code = useCode();
  const navigate = useNavigate();

  const { mutate } = useCancelOrderMutation({
    onMutate: () => {
      browse();
      navigate(`/${code}/products`);
      queryClient.invalidateQueries({
        queryKey: ['orders'],
      });
    },
  });

  const cancel = React.useCallback(() => {
    if (!orderId) return;

    mutate(orderId);
  }, [orderId]);

  return { cancel };
}
